<template>
  <router-link class="contract-item" :to="`/contract-detail/${contractId}`">
    <div class="title">{{ name }}</div>
    <div>合同金额: <span class="currency">￥{{ amount.toLocaleString() }}</span></div>
    <div>公司名称: {{ companyName }}</div>
    <div>签约日期: {{ signedDate }}</div>
    <div>到期日期: {{ endDate }}</div>
    <div :class="colorByType" class="type">{{ type }}</div>
  </router-link>
</template>

<script>
  export default {
    name: "ContractItem",
    computed: {
      colorByType() {
        switch (this.type) {
          case '正式':
            return 'type0';
          case '意向':
            return 'type1';
          case '已签':
            return 'type2';
          case '续约':
            return 'type3';
          default:
            return '';
        }
      }
    },
    props: {
      name: {
        type: String,
        required: true
      },
      amount: {
        type: Number,
        required: true
      },
      signedDate: {
        type: String,
        required: true
      },
      endDate: {
        type: String,
        default:''
      },
      companyName: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      contractId:{
        type:Number,
        required:true
      }
    }
  }
</script>

<style scoped>
  .contract-item {
    border-bottom: 1px solid #D8D8D8;
    padding: 10px 14px;
    font-size: 14px;
    color: #9A9A9A;
    line-height: 24px;
    position: relative;
    text-decoration: none;
    display: block;
  }

  .contract-item .title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }

  .contract-item .currency {
    color: #FD493A;
    font-size: 16px;
  }

  .contract-item .type {
    position: absolute;
    right: 14px;
    bottom: 10px;
  }

  .contract-item .type.type0 {
    /*正式*/
    color: #FD493A;
  }

  .contract-item .type.type1 {
    /*意向*/
    color: #F2A138;
  }

  .contract-item .type.type2 {
    /*已签*/
    color: #21B811;
  }

  .contract-item .type.type3 {
    /*续约*/
    color: #0090FF;
  }
</style>